const selectMovies = state => state.tmdbStore.movies;
const selectSearchMovieResults = state => state.tmdbStore.searchMovieResults;
const selectTmdbConfiguration = state => state.tmdbStore.tmdbConfiguration;

export const selectors = {
    selectMovies,
    selectSearchMovieResults,
    selectTmdbConfiguration
}